import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';

import SliderItemModel from '../../Api/Models/SliderItem';

import SliderItem from './SliderItem';

import SiteApi from 'Api/SiteApi/SiteApi';

type Props = Readonly<{ sliderslug: string; oldcomponentid: string; useDots?: string }>;

function Sliders({ sliderslug, oldcomponentid, useDots }: Props) {
    const [sliderItems, setSliderItems] = useState<SliderItemModel[]>([]);

    useEffect(() => {
        SiteApi.getSliderItems(sliderslug).then((sliders) => {
            setSliderItems(sliders);

            const oldComponent = document.getElementById(oldcomponentid);
            if (oldComponent) {
                if (sliders.length) {
                    oldComponent.remove();
                } else {
                    oldComponent.classList.remove('invisible', 'd-none');
                }
            }
        });
    }, []);

    if (!sliderItems.length) {
        return null;
    }

    return (
        <div className="container-fluid">
            <Slider
                dots={useDots != null}
                infinite
                autoplaySpeed={4000}
                slidesToShow={1}
                slidesToScroll={1}
                cssEase="linear"
                autoplay
                swipeToSlide={false}
                draggable={false}
                swipe={false}
                pauseOnHover={false}
            >
                {sliderItems.map((slide) => (
                    <SliderItem key={slide.image_url} slide={slide} />
                ))}
            </Slider>
        </div>
    );
}

export default Sliders;
